import { Component, OnInit, ViewChild } from '@angular/core';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { Router } from '@angular/router';
import { CpmService } from 'app/service/cpm.service';
import { MarketPerformanceComponent } from 'app/market-level/market-performance/market-performance.component';
import { CapitalRaisedIpoSoComponent } from 'app/market-level/capital-raised-ipo-so/capital-raised-ipo-so.component';
import { CapitalRaisedInstrumentsComponent } from 'app/market-level/capital-raised-instruments/capital-raised-instruments.component';
import { environment } from '../../../environments/environment';
import { ExportExcelService } from 'app/service/export-excel.service';
import { ExportPPTService } from '../../service/export-ppt.service';

@Component({
	selector: 'app-market-level-summary',
	templateUrl: './market-level-summary.component.html',
	styleUrls: ['./market-level-summary.component.scss'],
})
export class MarketLevelSummaryComponent implements OnInit {
	@ViewChild(MarketPerformanceComponent)
	marketPerformance: MarketPerformanceComponent;
	@ViewChild(CapitalRaisedIpoSoComponent)
	capitalRaisedIpoSo: CapitalRaisedIpoSoComponent;
	@ViewChild(CapitalRaisedInstrumentsComponent)
	capitalRaisedInstruments: CapitalRaisedInstrumentsComponent;

	constructor(private cpmService: CpmService, private excelService: ExportExcelService) {}

	exportFunctionsMarketPerformances() {
		const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
		arrayOfFunctions.set(
			'email',
			this.exportEmailMarketPerformances(this.marketPerformance.ytdValue, this.cpmService)
		);
		arrayOfFunctions.set('print', this.exportPrintMarketPerformances(this.marketPerformance.ytdValue));
		arrayOfFunctions.set('pdf', this.exportPdfMarketPerformances(this.marketPerformance.ytdValue));
		arrayOfFunctions.set('ppt', this.exportPptMarketPerformances(this.marketPerformance));
		arrayOfFunctions.set('excel', this.exportExcelMarketPerformances(this.marketPerformance));
		return arrayOfFunctions;
	}

	exportPrintMarketPerformances = function(ytdValue) {
		return function executiveSummaryPrint() {
			const popupWin = window.open(`/#/marketPerformance/${ytdValue}`, '_blank', 'width=850px,height=1024px');
		};
	};

	exportPdfMarketPerformances = function(ytdValue) {
		const service = this.cpmService;
		return function executiveSummaryPdf() {
			service.downloadFile(`${environment.cpmBaseUrl}/pdf/marketPerformance?ytd=${ytdValue}`);
		};
	};

	exportEmailMarketPerformances = function(ytdValue, service) {
		return function mailsectorPopup() {
			service.saveMarketPerformancePdfFile(ytdValue).then(filename => {
				const subject = 'Market Performance';
				const downloadUrl = encodeURIComponent(
					`${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
				);
				window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
			});
		};
	};

	exportPptMarketPerformances(marketPerformance) {
		return function PptCapRaised() {
			marketPerformance.Ppt();
		};
	}

	exportExcelMarketPerformances(marketPerformance) {
		return function excelMarketPerformances() {
			marketPerformance.exportExcel();
		};
	}

	exportFunctionsCapitaliposo() {
		const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
		arrayOfFunctions.set(
			'email',
			this.exportEmailCapitaliposo(this.capitalRaisedIpoSo.currentItem, this.cpmService)
		);
		arrayOfFunctions.set('print', this.exportPrintCapitaliposo(this.capitalRaisedIpoSo.currentItem));
		arrayOfFunctions.set('pdf', this.exportPdfCapitaliposo(this.capitalRaisedIpoSo.currentItem));
		arrayOfFunctions.set('ppt', this.exportPptCapRaisedByIpoSo(this.capitalRaisedIpoSo));
		arrayOfFunctions.set('excel', this.exportExcelCapRaisedByIpoSo(this.excelService, this.capitalRaisedIpoSo));
		return arrayOfFunctions;
	}

	exportPrintCapitaliposo = function(currentItem) {
		return function executiveSummaryPrint() {
			const popupWin = window.open(`/#/capitalRaisedIpo/${currentItem}`, '_blank', 'width=850px,height=1024px');
		};
	};

	exportPdfCapitaliposo = function(currentItem) {
		const service = this.cpmService;
		return function executiveSummaryPdf() {
			service.downloadFile(`${environment.cpmBaseUrl}/pdf/capitalRaisedIpo?type=${currentItem}`);
		};
	};

	exportEmailCapitaliposo = function(currentItem, service) {
		return function mailsectorPopup() {
			service.saveCapitaliposoPdfFile(currentItem).then(filename => {
				const subject = 'Capital Raised Ipo So';
				const downloadUrl = encodeURIComponent(
					`${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
				);
				window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
			});
		};
	};

	exportPptCapRaisedByIpoSo(capitalRaisedIpoSo) {
		return function PptCapRaised() {
			capitalRaisedIpoSo.Ppt();
		};
	}

	exportExcelCapRaisedByIpoSo(service, capitalRaisedIpoSo) {
		return function excelMarketPerformances() {
			if (capitalRaisedIpoSo.currentItem === 'M') {
				service.exportCapRaised(capitalRaisedIpoSo.dataProvider, 'Capital Raised by IPO and SO (Market cap)');
			} else {
				service.exportCapRaised(
					capitalRaisedIpoSo.dataProvider,
					'Capital Raised by IPO and SO (Capital raised)'
				);
			}
		};
	}

	exportFunctionsCapRaisedByInstrument() {
		const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
		arrayOfFunctions.set(
			'email',
			this.exportEmailCapRaisedByInstrument(this.capitalRaisedInstruments, this.cpmService)
		);
		arrayOfFunctions.set('print', this.exportPrintCapRaisedByInstrument(this.capitalRaisedInstruments));
		arrayOfFunctions.set('pdf', this.exportPdfCapRaisedByInstrument(this.capitalRaisedInstruments));
		arrayOfFunctions.set('ppt', this.exportPptCapRaisedByInstrument(this.capitalRaisedInstruments));
		arrayOfFunctions.set(
			'excel',
			this.exportExcelCapRaisedByInstrument(this.excelService, this.capitalRaisedInstruments)
		);
		return arrayOfFunctions;
	}

	exportPrintCapRaisedByInstrument = function(capitalRaisedInstrument) {
		return function executiveSummaryPrint() {
			window.open(
				`/#/capitalRaisedInstrument/${capitalRaisedInstrument.currentItem}/${
					capitalRaisedInstrument.currentItem2
				}`,
				'_blank',
				'width=850px,height=1024px'
			);
		};
	};

	exportPdfCapRaisedByInstrument = function(capitalRaisedInstrument) {
		const service = this.cpmService;
		return function executiveSummaryPdf() {
			service.downloadFile(
				`${
					environment.cpmBaseUrl
					// tslint:disable-next-line:max-line-length
				}/pdf/capitalRaisedInstrument?type=${capitalRaisedInstrument.currentItem}&groupType=${
					capitalRaisedInstrument.currentItem2
				}`
			);
		};
	};

	exportEmailCapRaisedByInstrument = function(capitalRaisedInstrument, service) {
		return function mailsectorPopup() {
			service
				.savecapitaRaisedInstrument(capitalRaisedInstrument.currentItem2, capitalRaisedInstrument.currentItem)
				.then(filename => {
					const subject = 'Capitalraised Instrument';
					const downloadUrl = encodeURIComponent(
						`${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
					);
					window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
				});
		};
	};

	exportPptCapRaisedByInstrument(capitalRaisedInstruments) {
		return function PptCapRaised() {
			return capitalRaisedInstruments.Ppt();
		};
	}

	exportExcelCapRaisedByInstrument(service, capitalRaisedInstrument) {
		return function excelMarketPerformances() {
			if (capitalRaisedInstrument.currentItem === '1') {
				service.exportCapitalValueForIpo(capitalRaisedInstrument.dataExportExcelIpo, 'CapitalValue Ipo');
			} else {
				service.exportCapitalValueForSo(capitalRaisedInstrument.dataProviderForSo, 'CapitalValue So');
			}
		};
	}

	ngOnInit() {}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-level-summary/market-level-summary.component.ts